import { FunctionComponent } from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import PickType from '../../types/pick';
import InsightPick from '@component/InsightPick';
import InsightPicksWrapper from './insightPicks.style';
import ArrowIcon from '../../public/icon/Arrow';

type InsightPicksType = {
  isMobile?: boolean;
  picks?: PickType[];
};
function SamplePrevArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, transform: 'rotate(90deg)', left: '-12px', top: 'calc(50% - 16px)' }}
      onClick={onClick}
    >
      <ArrowIcon width="25px" height="25px" />
    </div>
  );
}
function SampleNextArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, transform: 'rotate(-90deg)', right: '-14px', top: 'calc(50% - 12px)' }}
      onClick={onClick}
    >
      <ArrowIcon width="25px" height="25px" />
    </div>
  );
}

const InsightPicks: FunctionComponent<InsightPicksType> = ({ picks }) => {
  let settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <InsightPicksWrapper>
      <div className="insightpicks--picks-wrap">
        <Slider {...settings}>
          {picks?.map((pick) => (
            <Link href={`/insight/${pick.id}`} key={pick.id}>
              <a className="insightpicks--pick-link">
                <div className="insightpicks--pick">
                  <InsightPick pick={pick} />
                </div>
              </a>
            </Link>
          ))}
        </Slider>
      </div>
    </InsightPicksWrapper>
  );
};

export default InsightPicks;
